<!-- ----------------------------------------------- -->
<template>
  <div id="mapArea">
    <div id="kwb-map-view" class="map-map">
      <map-base></map-base>
      <map-zoom-control></map-zoom-control>
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import mixin from "../../lib/mixin.js";
import MapZoomControl from "../../components/map/ZoomControl";
import MapBase from "../../components/rp/RpMapBase.vue";
import WebStorage from "../../lib/webStorage.js";
import Util from "../../lib/util.js";

/**
 * 川の防災情報 地図画面
 * Map.vue
 * @author LIS
 */
export default {
  /** タグ名 */
  name: "kwb-map",
  mixins: [mixin],
  /** コンポーネント */
  components: {
    MapZoomControl,
    MapBase,
  },
  /** データ部 */
  data: () => ({
    /** 観測日時更新タイマーのインターバルID */
    appDateIntervalId: undefined,
    /** 任意お知らせ取得タイマーのインターバルID */
    anyInfoIntervalId: undefined,
    /** 緊急お知らせ取得タイマーのインターバルID */
    emergencyInfoIntervalId: undefined,
  }),
  /** 初期化部 */
  created() {
    // webストレージが未設定の場合は、初期値を設定する
    this.initWebStrage();
    this.initMap();
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 登録地点読み込み日時の取得 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 周辺観測所一覧 */
    tmPointDatas: {
      get() {
        return this.$store.state.Telemeter.tmPointDatas;
      },
    },
  },
  methods: {
    /** 初期化処理 */
    initMap() {
      // 地図の初期値設定
      this.$store.commit("map/init", {
        zoom: this.mapConfig.initZoom,
        center: this.mapConfig.initCenter,
        minZoom: this.mapConfig.minZoom,
        maxZoom: this.mapConfig.maxZoom,
        boundsArea: this.mapConfig.boundsArea,
        mapType: this.mapConfig.initMapType,
        viewGroup: this.mapConfig.initViewGroup,
        viewRadar: this.mapConfig.initViewRadar,
        viewRiverWarn: this.mapConfig.initViewRiverWarn,
        viewRiver: this.mapConfig.initViewRiver,
        viewPoint: this.mapConfig.initViewPoint,
      });

      // webストレージ編集日時設定
      this.$store.commit("map/setEditWebStorageDate", Util.toDate());

      // url解析
      const urlZoom = this.$route.query["zm"];
      const urlClat = this.$route.query["clat"];
      const urlClon = this.$route.query["clon"];
      if (urlClat != undefined && urlClon != undefined) {
        this.$store.commit("map/setCenter", [
          parseFloat(urlClat),
          parseFloat(urlClon),
        ]);
      }
      if (urlZoom != undefined) {
        this.$store.commit("map/setViewZoom", parseInt(urlZoom));
      }

      // 都道府県判定リスト、市町村判定リスト取得
      this.$store.dispatch("map/getPrefTownJadgeList");
    },
    /** webストレージの初期設定 */
    initWebStrage() {
      // 初期表示設定
      if (
        !WebStorage.getDefaultInfo() ||
        !Object.keys(WebStorage.getDefaultInfo()).length
      ) {
        let defaultInfo = {
          point1: false,
          point2: false,
          point3: false,
          point4: false,
          point5: false,
          pointDefault: true,
          disp1: false,
          disp2: false,
          disp3: false,
          disp4: false,
          disp5: false,
          dispCustom: false,
          general: true,
          flood: false,
        };
        // 表示観測所選択は設定ファイルの初期値に合わせて設定
        switch (this.mapConfig.initViewGroup) {
          case 0:
            defaultInfo.disp1 = true;
            break;
          case 1:
            defaultInfo.disp2 = true;
            break;
          case 2:
            defaultInfo.disp3 = true;
            break;
          case 3:
            defaultInfo.disp4 = true;
            break;
          case 4:
            defaultInfo.disp5 = true;
            break;
          case 5:
            defaultInfo.dispCustom = true;
            break;
        }
        WebStorage.setDefaultInfo(defaultInfo);
      }
      // カスタマイズ設定
      if (
        !WebStorage.getCustomInfo() ||
        !Object.keys(WebStorage.getCustomInfo()).length
      ) {
        WebStorage.setCustomInfo({
          stage: false,
          dam: false,
          rain: false,
          cctv: false,
          scam: false,
          wtrQual: false,
          coast: false,
          snow: false,
          swin: false,
          fldfr: false,
          damdsch: false,
          fldctl: false,
        });
      }
    },
  },
  watch: {
    /** 登録地点読み込み日時の変更を検知し、登録地点の情報を取得する */
    editWebStorageDate() {
      this.$store.dispatch("map/getRegistrationPointInfo");
    },
    /** 周辺観測所が更新された場合に、webストレージへの書き込み行う */
    tmPointDatas() {
      switch (this.tmPointDatas.pointIndex) {
        case 0:
          WebStorage.setPoint1Info(this.tmPointDatas);
          break;
        case 1:
          WebStorage.setPoint2Info(this.tmPointDatas);
          break;
        case 2:
          WebStorage.setPoint3Info(this.tmPointDatas);
          break;
        case 3:
          WebStorage.setPoint4Info(this.tmPointDatas);
          break;
        case 4:
          WebStorage.setPoint5Info(this.tmPointDatas);
          break;
      }
      // webストレージ編集日時を更新
      this.$store.commit("map/setEditWebStorageDate", Util.toDate());
      // 登録中フラグを0にする
      this.$store.commit("map/setEditFlag", 0);
      // リスク収集フラグを0にする
      this.$store.commit("viewConfig/setRiskFlg", 0);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#mapArea {
  z-index: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .map-map {
    z-index: 1;
    position: relative;
    flex: 1;
  }
}
</style>
